var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaign)?_c('div',{staticClass:"single-ad"},[_c('a',{attrs:{"href":_vm.campaign.link,"target":_vm.campaign.open_in_new_window ? '_blank' : '',"aria-label":_vm.alt_text}},[_c('img',{attrs:{"src":_vm.image.image,"alt":_vm.alt_text}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }